module.exports = __webpack_public_path__ + "assets/img/13_369_big.ad939d50.jpg";